module.exports = __webpack_public_path__ + "static/media/burlingame11.187c751a.jpg";